import "./SingleProductTemplate.module.css"
import MainNavigation from "@/reusable_sections/Header"
import SingleProductTemplateSection from "./sections/SingleProductTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SingleProductTemplatePage() {

  return (
    <div>
      <MainNavigation />
      <SingleProductTemplateSection />
      <Footer />
    </div>
  )
}
